export const CHALLENGE_LANGUAGE_OBJECT = "challenge_a8s6fas8sg";